module.exports = __webpack_public_path__ + "static/media/galia-testimonial.1e2d56dc.png";